import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { Divider } from "@/components/General/Divider/divider.component";
import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { OTHER_FEATURE_VALUE } from "@/components/PaintConfigurator/helpers/feature.helper";

import { useVolumesContext } from "../context/volumes.context";

const Volume = () => {
    const { volumes } = useVolumesContext();
    const { setSelectedVolume, nextStep } = usePaintConfiguratorContext();
    const { index } = useMapped();
    const volumeInfo = volumes.at(index);

    if (!volumeInfo) return null;

    return (
        <Button
            className={cn(
                "tw:group tw:p-0 tw:ring-1 tw:overflow-hidden tw:ring-gray-300 tw:hover:ring-offset-2 tw:hover:scale-[1.01] tw:transition-all"
            )}
            color="transparent"
            onClick={() => {
                setSelectedVolume(volumeInfo.volume.value);
                nextStep();
            }}
        >
            <div
                className={cn(
                    "tw:p-3 tw:align-middle tw:bg-background tw:text-grey-dark tw:text-sm"
                )}
            >
                <p className={cn("tw:m-0!")}>
                    {volumeInfo.volume.value.toUpperCase()}
                </p>
                {volumeInfo.coverage.value !== OTHER_FEATURE_VALUE && (
                    <>
                        <Divider className={cn("tw:mb-3")} />
                        <p className={cn("tw:text-sm")}>
                            {`${volumeInfo.coverage.name} - ${volumeInfo.coverage.value}`}
                        </p>
                    </>
                )}
            </div>
        </Button>
    );
};

export { Volume };
